import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-24b07a8f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "container-fluid",
  style: {"padding":"0 10%"}
}
const _hoisted_2 = { class: "jumbotron" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Профиль пользователя ")
const _hoisted_4 = { class: "Profile-buttons" }
const _hoisted_5 = { class: "card" }
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = { class: "Profile-text" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "ФИО:", -1))
const _hoisted_9 = {
  key: 0,
  class: "Changes-warning"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dx-button-text" }, "Сохранить ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxTextBox = _resolveComponent("DxTextBox")!
  const _component_DefinePasswordControl = _resolveComponent("DefinePasswordControl")!
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_DxButton = _resolveComponent("DxButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("h1", null, [
        _hoisted_3,
        _createElementVNode("strong", null, _toDisplayString(_ctx.currentUser.username), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, [
            _hoisted_8,
            _createVNode(_component_DxTextBox, {
              class: "Profile-textBox",
              stylingMode: "outlined",
              placeholder: "ФИО",
              "show-clear-button": true,
              value: _ctx.tempObject.fullName,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tempObject.fullName) = $event)),
              onValueChanged: _ctx.haveChanges
            }, null, 8, ["value", "onValueChanged"])
          ]),
          _createVNode(_component_DefinePasswordControl, {
            class: "Profile-password",
            value: _ctx.tempObject.password,
            "onUpdate:value": [
              _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tempObject.password) = $event)),
              _ctx.haveChanges
            ]
          }, null, 8, ["value", "onUpdate:value"])
        ])
      ]),
      (_ctx.changes)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, " Изменения вступят в силу после сохранения "))
        : _createCommentVNode("", true),
      _createVNode(_component_DxButton, {
        class: "Profile-save",
        type: "default",
        onClick: _ctx.save,
        "styling-mode": "outlined"
      }, {
        content: _withCtx(() => [
          _createElementVNode("span", null, [
            (_ctx.saving)
              ? (_openBlock(), _createBlock(_component_FontAwesomeIcon, {
                  key: 0,
                  icon: "circle-notch",
                  spin: ""
                }))
              : _createCommentVNode("", true),
            _hoisted_10
          ])
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_DxButton, {
        "styling-mode": "outlined",
        class: "Profile-reset",
        type: "default",
        text: "Отмена",
        onClick: _ctx.reset,
        disabled: !_ctx.changes
      }, null, 8, ["onClick", "disabled"])
    ])
  ]))
}